import React from 'react';
import { ExternalLink } from 'lucide-react';

export default function Leadership() {
    return (
        <section id="leadership" className="mb-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold mb-6 pb-2 border-b-2 border-blue-500">LEADERSHIP & VOLUNTEERING</h2>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex justify-between items-start flex-wrap mb-2">
                    <h3 className="font-bold text-lg text-blue-800">Lead Organizer | prAkshepan 2.0 – Fresher Orientation Program</h3>
                    <a href="https://www.linkedin.com/posts/agarwalkritik_prakshepan-departmentofcse-cse-activity-7225824357875335169-4Ue1?utm_source=share&utm_medium=member_desktop&rcm=ACoAACMnPCEBpVbc1Injp4ZcOI6DPAdS_MsCLGA"
                        className="flex items-center gap-1 text-blue-600 hover:text-blue-800 underline">
                        <ExternalLink size={16} />
                        Linkedin Post
                    </a>
                </div>
                <p className="italic mb-4">Department of Computer Science & Engineering, IIT Hyderabad</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li className="hover:bg-gray-100 transition duration-300">Conceptualized and led "<strong>prAkshepan 2.0</strong>", a flagship event to welcome and integrate M.Tech CSE freshers through interactive sessions, faculty talks, and technical quizzes.</li>
                    <li className="hover:bg-gray-100 transition duration-300">Coordinated with department faculty, alumni, and senior students to organize mentorship sessions on TA/RA roles, academic expectations, and campus life.</li>
                    <li className="hover:bg-gray-100 transition duration-300">Strengthened the department's onboarding culture and enriched the legacy of <strong>prAkshepan 1.0</strong>, established by our senior batch, contributing to the positive integration of freshers into the department.</li>
                </ul>
            </div>
        </section>
    );
}
